import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

import { errorToast, successToast } from "utils/toasts";
import { type ProductPropertyUpdateSchema } from "zodios/apiDefinitions/api/products";

export function useBulkUpdateProductProperties() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (vars: ProductPropertyUpdateSchema) => {
      await apiClient.bulkUpdateProductProperties(vars);
    },
    onSuccess: () => {
      successToast({ message: `Products Successfully Updated` });
      void queryClient.invalidateQueries();
    },
    onError: (error) => {
      errorToast({ message: `Failed to Update Products`, error });
    },
  });
}
